// Convert tabs to dropdown on mobile
export default function tabsDropdown() {
    const tabsDropdown = document.querySelector(".gb-tabs__buttons");

    if (tabsDropdown) {
        tabsDropdown.addEventListener("click", function (e) {
            tabsDropdown.classList.toggle("active");
            if (tabsDropdown.classList.contains("active")) {
                tabsDropdown.setAttribute("aria-expanded", "true");
            } else {
                tabsDropdown.setAttribute("aria-expanded", "false");
            }
        });
    }
}
